import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./pageVisitLoader.css";

export default function PageVisitLoader() {
  var location = useLocation();
  var [on, setOn] = useState(false);

  useEffect(function () {
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    setOn(true);
    var timer = window.setTimeout(function () { setOn(false); }, reduce ? 200 : 450);
    return function () { window.clearTimeout(timer); };
  }, [location.pathname, location.search]);

  if (!on) return null;

  return (
    <div className="pa-visit" role="status" aria-label="Loading">
      <span className="pa-visit__spin" aria-hidden="true" />
    </div>
  );
}
